import AclName from '../../acl/AclName';
import model from '../../models-v2/crm/banking-operations';
import routeName from '../route-name';

export default [
  {
    path: '/banking-operations',
    name: routeName.bankingOperations.index,
    components: {
      default: () => import('../../pages/data-grid.vue'),
      topRightSection: () => import('../../pages/crm/banking-operations/BankingOperationsTopRightSection.vue'),
      popup: () => import('../../pages/crm/banking-operations/Popup.vue'),
    },
    meta: {
      acl: AclName.CrmPageBankingOperationsList,
      breadcrumb: [
        { title: 'CRM', url: '/clients' },
        { title: 'Operacje bankowe', url: '/banking-operations' },
      ],
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/banking-operations/settle/:id',
    name: routeName.bankingOperations.settle,
    meta: {
      acl: AclName.CrmPageBankingOperationsSettle,
      breadcrumb: [
        { title: 'CRM', url: '/clients' },
        { title: 'Operacje bankowe', url: '/banking-operations' },
      ],
      search: false,
      module: 'CRM',
    },
    component: () => import('../../pages/crm/banking-operations/Settle.vue'),
    props: (route) => ({ id: Number(route.params.id) }),
  },
  {
    //todo change to popup when more than popup will be avaible on data-grid
    path: 'banking-operations/settle/manually/:id',
    name: routeName.bankingOperations.manually_settle,
    component: () => import('../../pages/crm/banking-operations/ManuallyStatus.vue'),
    meta: {
      acl: AclName.CrmPageBankingOperationsSettle,
      breadcrumb: [
        { title: 'Operacje bankowe', url: '/banking-operations' },
      ],
    },
    props: (route) => ({ id: Number(route.params.id) }),
  },
];
